import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import MessageModalStore from '@src/business-components/news-swiper/components/message-modal/store';
import ModalContainer from '@src/components/modal-container';
import { noop } from '@src/utils/common-util';
import Link from '@src/components/link';

/**
 * MessageModal
 * @param store {MessageModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const MessageModal = ({ store, onClose = noop }) => {
  store.use();
  store.onClose = onClose;
  const renderContainer = () => {
    // if (store.mode === store.IMG_MODE.horizontal) {
    if (store.mode === store.IMG_MODE.vertical) {
      return (
        <div className={styles.container}>
          <div className={styles.content}>{store.messageImg && <img src={store.messageImg} alt={''} />} </div>
          {/*<div className={styles.content}>{<img src="https://www.mechabreak.cn/uploadfile/2024/1203/20241203033509127.jpg" alt={''} />} </div>*/}
          <div className={styles.containerImg} />
          <Link className={styles.closeBtn} onClick={store.onClose} />
        </div>
      );
      // } else if (store.mode === store.IMG_MODE.vertical) {
    } else if (store.mode === store.IMG_MODE.horizontal) {
      return (
        <div className={cx(styles.horizontalContainer)}>
          <div className={styles.content}>{store.messageImg && <img src={store.messageImg} alt={''} />} </div>
          {/*<div className={styles.content}>{<img src="https://www.mechabreak.cn/uploadfile/2024/1203/20241203033509127.jpg" alt={''} />} </div>*/}
          <div className={styles.containerImg} />
          <Link className={styles.closeBtn} onClick={store.onClose} />
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <ModalContainer modalState={store.modalStatus}>
      <div className={cx(styles.root)}>{renderContainer()}</div>
    </ModalContainer>
  );
};

export default wrapStore(MessageModal, MessageModalStore);
